module.exports = __webpack_public_path__ + "img/policy.a19be767.png";